module.exports = __webpack_public_path__ + "static/media/Undo.c475033d.svg";